import Moment from "react-moment";
import React, { useEffect, useState } from "react";
import { getFormatedNumber } from "../../services/appService";
import ActiveDeactiveHistory from "../../components/SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { SendReminder, getReminderStatus, receivedCandidateById } from "../store/candidate";
import { getAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import Document from "../../components/PortalForms/Document";
import { getSubcontractorBprmForm, loadSubcontractorBprmForm, receivedSubcontractorById, subsCurrentWfTaskReceived } from "../store/subcontractor";
import { getRecruiterBprmForm, loadRecruiterBprmForm, recCurrentWfTaskReceived, receivedRecruiterById } from "../store/recruiter";
import WorkflowElement from "./WorkflowElement";
import config from "../../config.json";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived } from "../store/documents";
import { formLibraryReceived } from "../store/forms";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";

export default function PartnerInfo(props) {

    const { module, partner: item, type, appType, handleshowtable } = props;
    const [logShowHide, setLogShowHide] = useState(false);
    const [actionType, setActionType] = useState("");

    const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);
    const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
    const [selectedApp, setSelectedApp] = useState(null);
    const [viewRowType, setViewRowType] = useState("");
    const [appDocuments, setAppDocuments] = useState([]);
    const [updatedStateData, setUpdatedStateData] = useState(null);
    const [viewFormType, setViewFormType] = useState("");
    const [wfTask, setWfTask] = useState(null);
    const [wfForm, setWfForm] = useState(null);

    const [achType, setAchType] = useState("");
    const [insuranceType, setInsuranceType] = useState("");
    const [selectedInfo, setSelectedInfo] = useState("");
    const [editDurType, setEditDurType] = useState("");
    const [fetchedDataType, setFetchedDataType] = useState("");
    const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

    const remiderStatusSelector = useSelector(getReminderStatus);
    const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
    const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)

    const dispatch = useDispatch();

    useEffect(() => {
        if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
    }, [subcontractorBprmFormSelector])

    useEffect(() => {
        if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
    }, [recruiterBprmFormSelector])

    useEffect(() => {
        if (remiderStatusSelector === "success") {
            getAlert("", "Reminder Sent Successfully", "success");
        }
    }, [remiderStatusSelector]);

    const handleRemainder = async (id) => {
        dispatch(SendReminder(id));
    };

    const handleRemainderMessage = () => {
        setRemainderMsgShowHide(!remainderMsgShowHide);
    };

    const handleLogShowHide = (item, actionType) => {
        if (item === "save") {
            setLogShowHide(false);
            setActionType(actionType);
        } else {
            setLogShowHide(!logShowHide);
            setActionType(actionType);
        }
    };

    const handleDocumentViewShowHide = (type, app) => {
        if (viewRowType === type) return;
        handleCloseDocumentView();
        setViewRowType(type);
        setEditDurType(type);
        setSelectedInfo(type);
        handleshowtable(true)
        const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        setSelectedApp(app);
    };

    const handleCloseDocumentView = () => {
        setViewFormType("");
        setUpdatedStateData("");
        setViewRowType("");
        setSelectedApp(null);
        setSelectedCurrentTask(null);
        handleshowtable(false);
        setEditDurType("");
        setSelectedInfo("");
        dispatch(documentReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(formLibraryReceived([]));
        dispatch(reqDocumentReceived([]));
        dispatch(esignDocumentsReceived([]));
    }


    const handleViewSubcontractorForm = (type, item) => {
        setViewRowType("");
        setSelectedApp(null);
        setSelectedCurrentTask(null);
        if (viewFormType === type) {
            setViewFormType("");
            handleshowtable(false)
            setUpdatedStateData()
        } else {
            if (item.partnerType === "Sub-Contractors") {
                setWfTask({ formId: config.formIds.subcontractor, ciid: 0 });
                dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
            } else {
                setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
                dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
            }
            setViewFormType(type);
            handleshowtable(true)
            //   setSelectedFormKey(key);
            if (item.applications?.length > 0)
                setUpdatedStateData(item.applications[0].applicationData);
            else
                setUpdatedStateData(item.contact1.performerData);
        }
    }

    const handleNextTask = () => {
        console.log("")
    }

    const handleACHShowHide = (mod, type, item, key, app) => {
        if (achType == type) return;
        dispatch(formLibraryReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(receivedSubcontractorById([]));
        dispatch(receivedCandidateById([]));
        dispatch(receivedRecruiterById([]));
        setSelectedInfo(mod);
        //setSelectedKey(key);
        setFetchedDataType("")
        setEditDurType("");
        setAchType(type);
        setInsuranceType("");
        handleshowtable(true)
        const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        setSelectedApp(app);
    }

    const handleInsuranceShowHide = (mod, type, item, key, app) => {
        if (insuranceType == type) return;
        dispatch(formLibraryReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(receivedSubcontractorById([]));
        dispatch(receivedCandidateById([]));
        dispatch(receivedRecruiterById([]));
        setSelectedInfo(mod);
        //setSelectedKey(key);
        setFetchedDataType("")
        setEditDurType("");
        setAchType("");
        setInsuranceType(type);
        handleshowtable(true)
        const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        setSelectedApp(app);
    }

    const closeACHInsu = () => {
        setSelectedInfo("");
        //setSelectedKey(-1);
        setAchType("");
        setInsuranceType("");
        handleshowtable(false)
    }

    return (
        <React.Fragment>
            <div className="table-responsive border">
                <table className="table align-items-center table-flush table-hover table-striped mb-2">
                    <thead className="thead-light">
                        <tr>
                            <th>ID #</th>
                            <th>{module} Details</th>
                            <th>Key Contact</th>
                            {module !== "Recruiter" && <th>Entity Type</th>}
                            <th>Enrollment Status</th>
                            {type === "partner" && <th>Active Users</th>}
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{item.fuid}</td>
                            <td>
                                {/* <span className="text-uppercase">
                                    {item.label}
                                </span> */}
                                <button
                                    onClick={() => handleViewSubcontractorForm("Form", item)}
                                    className="btn p-0 btn-link btn-sm text-uppercase">
                                    {item.label}
                                </button>
                                <br />
                                {item.email}
                                <br />
                                <Moment format="MMM Do YYYY, h:mm a">
                                    {item.createdDate}
                                </Moment>
                            </td>
                            <td>
                                {item?.contact1 && (
                                    <React.Fragment>
                                        <span className="text-uppercase">
                                            {item.contact1.performername}&nbsp;{item.contact1.lastName}
                                        </span>
                                        <br />
                                        {item.contact1.performeremail}
                                        <br />
                                        {getFormatedNumber(item.contact1.contactNo)}
                                    </React.Fragment>
                                )}
                            </td>
                            {module !== "Recruiter" && <td>C2C</td>}
                            <td>
                                {item.enrollmentStatus && "Complete"}
                                {!item.enrollmentStatus && "Pending"}
                                <br />
                                {item.contact1 !== null && type === "partner" && (
                                    <React.Fragment>
                                        <button
                                            className="btn btn-link btn-sm p-0 m-0 text-underline"
                                            onClick={() => handleRemainder(item.contact1.performerid)}
                                        >
                                            Send Reminder
                                        </button>
                                        <br />
                                        <button
                                            className="btn btn-link btn-sm p-0"
                                            title="View message"
                                            onClick={handleRemainderMessage}
                                        >
                                            <span className="badge badge-warning rounded-0 text-red">
                                                <i
                                                    class="fa fa-envelope mr-1"
                                                    aria-hidden="true"
                                                ></i>
                                                {!item.contact1?.msgAlertCount
                                                    ? 0
                                                    : item.contact1.msgAlertCount}
                                            </span>
                                        </button>
                                    </React.Fragment>
                                )}
                            </td>
                            {type === "partner" && (
                                <td>
                                    <span
                                        className="badge badge-success w-50 rounded-0"
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                        }}
                                    >
                                        {item.activeUsers}
                                    </span>
                                </td>
                            )}
                            <td>
                                {type === "partner"
                                    ? item.contact1 !== null && (
                                        <React.Fragment>
                                            {item.contact1.isActive === true && (
                                                <button
                                                    className="btn btn-sm btn-link p-0 text-underline"
                                                    onClick={() =>
                                                        handleLogShowHide(item)
                                                    }
                                                >
                                                    <i
                                                        className="fa fa-check-square"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    Activated
                                                </button>
                                            )}
                                            {item.contact1.isActive === false && (
                                                <button
                                                    className="btn btn-sm btn-link p-0 text-underline"
                                                    onClick={() =>
                                                        handleLogShowHide(item)
                                                    }
                                                >
                                                    Deactivated
                                                </button>
                                            )}
                                            {item.contact1.isActive === null && (
                                                <button
                                                    className="btn btn-sm btn-link p-0 text-underline"
                                                    onClick={() =>
                                                        handleLogShowHide(item)
                                                    }
                                                >
                                                    To Activate
                                                </button>
                                            )}
                                            <br />
                                            {item.contact1.isActive !== null && (
                                                <button
                                                    className="btn btn-sm btn-link p-0 text-underline mt-2"
                                                    onClick={() =>
                                                        handleLogShowHide(item)
                                                    }
                                                >
                                                    Log History
                                                </button>
                                            )}
                                        </React.Fragment>
                                    )
                                    : item?.contact1 && (
                                        <React.Fragment>
                                            {item.contact1.isActive === true && (
                                                <>
                                                    <i
                                                        className="fa fa-check text-success"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    Activated
                                                </>
                                            )}
                                            {item.contact1.isActive === false && (
                                                <>
                                                    <i
                                                        className="fa fa-times text-danger"
                                                        aria-hidden="true"
                                                    ></i>{" "} Deactivated
                                                </>
                                            )}
                                            {item.contact1.isActive === null && (
                                                <>
                                                    To Activate
                                                </>
                                            )}
                                        </React.Fragment>
                                    )}
                            </td>
                        </tr>
                        <tr className="bg-white">
                            {item.applications.map((app) => (
                                <React.Fragment key={app.applicationId}>
                                    <td colSpan={1} className="border-0 pt-0 pb-0"></td>
                                    <td colSpan={1} className="border-0 pt-0 pb-0" >
                                        <>
                                            {/* {type === "application" &&  */}
                                            <tr>
                                                <td className="text-left pt-0 pl-0 border-0">
                                                    <button
                                                        onClick={() => handleDocumentViewShowHide("Document", app)}
                                                        className="btn btn-sm btn-link p-0"
                                                        title="Contract Documents"
                                                    >
                                                        Send Contract Documents
                                                    </button>
                                                    <br />
                                                    <button
                                                        onClick={() => handleACHShowHide("ACH", "Subcontractor", item, 1, app)}
                                                        className="btn btn-sm btn-link p-0"
                                                        title="Contract Documents"
                                                    >
                                                        ACH Information <span className="badge badge-pill badge-danger">{app?.achRequest}</span>
                                                    </button>
                                                    <br />
                                                    <button
                                                        onClick={() => handleInsuranceShowHide("Insurance", "Subcontractor", item, 1, app)}
                                                        className="btn btn-sm btn-link p-0"
                                                        title="Contract Documents"
                                                    >
                                                        Insurance Information <span className="badge badge-pill badge-danger">{app?.insuranceRequest}</span>
                                                    </button>
                                                </td>

                                            </tr>

                                        </>
                                    </td>
                                    <td colSpan={4} className="border-0 pt-0 pb-0"></td>
                                </React.Fragment>
                            ))}
                        </tr>
                        <tr >
                            {selectedInfo === "Document" &&
                                <td colSpan={7} className="bg-white p-3">
                                    <div className="text-left mb-3 pr-0">
                                        <button
                                            className="btn btn-sm btn-outline-default"
                                            onClick={() => handleCloseDocumentView("Document", null)}
                                        >
                                            <i className="fa fa-times mr-2"></i>Close
                                        </button>
                                    </div>
                                    <Document
                                        documents={appDocuments}
                                        workflowTask={selectedCurrentTask}
                                        uploadType={item?.partnerType === "Sub-Contractors" ? "Subcontractor" : "Recruiter"}
                                        app={selectedApp}
                                        item={item}
                                        viewType={""}
                                        pageModule={"review"}
                                    />
                                </td>}
                            {selectedInfo === "ACH" &&
                                <td colSpan={13} className="bg-white p-3">
                                    <div className="text-left pr-0">
                                        <button
                                            className="btn btn-sm btn-outline-default"
                                            onClick={() => closeACHInsu()}
                                        >
                                            <i className="fa fa-times mr-2"></i>Close
                                        </button>
                                    </div>
                                    <div className="text-center mt--4"><h3>{achType} ACH Information</h3></div>
                                    <AchInformation
                                        workflowTask={selectedCurrentTask}
                                        app={selectedApp}
                                        item={item}
                                        setViewBprmFormShowHide={setViewBprmFormShowHide}
                                        viewType={"subcontractorList"}
                                        achType={achType}
                                        setSelectedApp={setSelectedApp}
                                    />
                                </td>}
                            {selectedInfo === "Insurance" &&
                                <td colSpan={13} className="bg-white p-3">
                                    <div className="text-left pr-0">
                                        <button
                                            className="btn btn-sm btn-outline-default"
                                            onClick={() => closeACHInsu()}
                                        >
                                            <i className="fa fa-times mr-2"></i>Close
                                        </button>
                                    </div>
                                    <div className="text-center mt--4"><h3>{insuranceType} Insurance Information</h3></div>
                                    <InsuranseInformation
                                        workflowTask={selectedCurrentTask}
                                        app={selectedApp}
                                        item={item}
                                        setViewBprmFormShowHide={setViewBprmFormShowHide}
                                        viewType={"subcontractorList"}
                                        insuranceType={insuranceType}
                                        setSelectedApp={setSelectedApp}
                                    />
                                </td>}
                        </tr>
                    </tbody>
                </table>
            </div>
            {wfForm && updatedStateData &&
                <div className="p-3 border mt-2">
                    <div className="text-left mb-3 pr-0">
                        <button
                            className="btn btn-sm btn-outline-default mb-4"
                            onClick={() => handleViewSubcontractorForm(`${viewFormType}`, null)}
                        >
                            <i className="fa fa-times mr-2"></i>Close
                        </button>
                    </div>
                    <WorkflowElement
                        wfTask={wfTask}
                        wfForm={wfForm}
                        handleNextTask={handleNextTask}
                        viewType={true}
                        appSummary={false}
                        codeVerified={true}
                        wfTaskType={"form"}
                        // actionType={"workflow"}
                        updatedStateData={updatedStateData}
                    />
                </div>}
            {/* <ActiveDeactiveHistory
                logShowHide={logShowHide}
                handleLogShowHide={handleLogShowHide}
                selectedObj={item}
                type={appType}
                pageType={module}
                actionType={actionType}
            ></ActiveDeactiveHistory> */}
        </React.Fragment>
    )
}